const faq = [
  {
    question: "How do I create an account with Elegant Store?",
    answer:
      "You can't create an account, there is no authentication implemented yet, this is just a demo website.",
  },
  {
    question: "Are all products on Elegant original and authentic?",
    answer:
      "Yes, we are committed to offering our customers only the best authentic and 100% original products. We also take all the necessary measures to ensure this: any seller who sells fake/counterfeit products is liable to penalties. Please contact us here if you believe that a product listed on our website does not meet these standards.",
  },
  {
    question: "Do I need an account to purchase from Elegant Store?",
    answer:
      "Nah, we cool cats here, you don't need to have an account for that.",
  },
  {
    question: "How many times will you reattempt my delivery?",
    answer:
      "We will make a maximum of 2 attempts to deliver your parcel. If we are unable to deliver after the second attempt, we will cancel your delivery and return the parcel to our warehouse for a refund where applicable",
  },
  {
    question: "How can I track my order?",
    answer:
      "We will send you regular updates about the status of your order via emails and SMS. Once your order has left our warehouse, you can track its status by using your tracking number.",
  },
  {
    question:
      "Are there any hidden costs or charges if I order from Elegant Store?",
    answer:
      "There are no hidden costs or charges when you order from Elegant Store. All costs are 100% visible at the end of the checkout process.",
  },
  {
    question: "Will I receive all the items in my order at once?",
    answer:
      "You may receive items in your order separately because they are sold by different sellers and are shipped at different times.",
  },
  {
    question: "How do I return a item?",
    answer:
      "If you return an item/s and select store credit as your refund method, or an item happens to be out of stock a store credit voucher code will be emailed to you to the value of the paid price of the item/s. This can then be used for future purchases at Elegant Store Store credits will be received only once the returned items have been processed by Quality Control. To qualify for store credit, items must be returned unworn in its original packaging and not damaged.",
  },
];

export default faq;
